import { ReactNode } from 'react'
import { Link, type LinkProps } from 'react-router-dom'
import { LuChevronRight } from 'react-icons/lu'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import type { SxProps, Theme } from '@mui/material/styles'

type Props = {
  to: string
  icon: ReactNode
  children: ReactNode
  disabled?: boolean
  sx?: SxProps<Theme>
  state?: LinkProps['state']
}

export default function ListItemLink({ to, icon, children, disabled, sx, state }: Props) {
  return (
    <ListItemButton component={Link} to={to} state={state} disabled={disabled} sx={sx}>
      <ListItemIcon sx={{ minWidth: 26, color: 'contrast.medium' }}>{icon}</ListItemIcon>
      <ListItemText>{children}</ListItemText>
      <LuChevronRight />
    </ListItemButton>
  )
}
